import React from 'react';
import SapMMProcess from '../function-components/learningCourses/SapMMProcess';

const SapMM = () => {
  return (
    <SapMMProcess />
  )
}

export default SapMM